import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import RecordDetails from "./RecordDetails";
import SurvivorshipDomainBusinessRules from "./SurvivorshipDomainBusinessRules";

const TrustRules = ({ features }) => {
  const CLIENT_ROUTES = {
    "Record Details": {
      component: RecordDetails,
      path: "record-details",
    },
    "Business Rules": {
      component: SurvivorshipDomainBusinessRules,
      path: "business-rules",
    },
  };

  return (
    <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
  );
};

export default TrustRules;
